import styled from 'styled-components';

export const ContentRowWrapper = styled.div<{ backgroundColor?: string }>`
  display: block;
  padding: 15px;
  background-color: ${({ backgroundColor, theme }) => backgroundColor || theme.color.secondaryBackground};
`;

export const TextColumn = styled.div`
  white-space: pre-wrap;
  width: 100%;
`;

export const ContentCopy = styled.div`
  width: 100%;

  &::after {
    content: '';
    display: block;
    clear: both;
  }
`;

export const ContentButtonContainer = styled.div`
  padding-top: 1rem;
`;

export const ContentTitle = styled.h2`
  margin: 0 0 0.75rem;
  color: ${({ theme }) => theme.color.primaryText};
`;

export const ContentText = styled.p`
  margin: 0 0 1rem;
  color: ${({ theme }) => theme.color.primaryText};
  white-space: pre-wrap;
`;

export const ContentImage = styled.img`
  display: block;
  width: auto;
  height: auto;
  max-height: 200px;
  object-fit: cover;

  &.align-left {
    float: left;
    width: 50%;
    max-width: 50%;
    margin: 0 15px 10px 0;
  }

  &.align-right {
    float: right;
    width: 50%;
    max-width: 50%;
    margin: 0 0 10px 15px;
  }

  &.align-center {
    display: block;
    width: 100%;
    margin: 0 auto 15px;
    max-width: 100%;
  }

  @media (max-width: 768px) {
    float: none !important;
    display: block;
    width: 100% !important;
    max-width: 100% !important;
    margin: 0 0 15px 0 !important;
  }
`;

export const ShowMoreButtonInline = styled.button`
  background: none;
  border: none;
  color: ${({ theme }) => theme.color.primaryText};
  text-decoration: underline;
  cursor: pointer;
  font-size: inherit;
  padding: 0;
  margin-left: 0.25rem;
  display: inline;

  &:hover {
    opacity: 0.8;
  }
`;
